import {api} from '../api';

export async function getTransmission(){
    try{
        const {data:{transmissao}} = await api.get(`/transmissao`)
        return transmissao
    }
    catch(error){
        return false
    }
}
export async function getContactsInTransmission(id){
    try{
        const {data:{contatos}} = await api.get(`/transmissao-destinatario?id=${id}`)
        return contatos
    }
    catch(error){
        return false
    }
}
export async function postTransmission(name,description){
    try{
        const {data:{transmissao}} = await api.post(`/transmissao?nome=${name}&descricao=${description}`)
        return transmissao
    }
    catch(error){
        return false
    }
}
export async function putTransmission(id,name,description){
    try{
        const {data:{transmissao}} = await api.put(`/transmissao?id=${id}&nome=${name}&descricao=${description}`)
        return transmissao
    }
    catch(error){
        return false
    }
}
export async function creatContactInTransmission(transmissao_id,client_id){
    try{
        const {data} = await api.post(`/transmissao-destinatario?transmissao_id=${transmissao_id}&client_id=${client_id}`)
        return data
    }
    catch(error){
        return false
    }
}
export async function deleteContactInTransmission(transmissao_id,client_id){
    try{
        const {data} = await api.delete(`/transmissao-destinatario?transmissao_id=${transmissao_id}&id=${client_id}`)
        return data
    }
    catch(error){
        return false
    }
}
export async function sendTemplateTransmissao(dataSend){
    try{
        return await api.post(`/send_template_transmissao`,dataSend)
    }
    catch(error){
        return false
    }
}